import React from 'react';
import { ClipboardList, ArrowRight } from 'lucide-react';

export default function ListYourShow() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 mb-12">
      <div className="bg-gradient-to-br from-[#f0f7fc] to-[#e6f0fa] border border-blue-50 rounded-3xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between shadow-[0_8px_30px_rgb(0,0,0,0.06)] relative overflow-hidden group">
         
         {/* Decorative background glows */}
         <div className="absolute top-0 right-0 w-72 h-72 bg-blue-300 rounded-full opacity-20 -translate-y-1/2 translate-x-1/3 blur-3xl pointer-events-none"></div>
         <div className="absolute bottom-0 left-0 w-56 h-56 bg-indigo-300 rounded-full opacity-20 translate-y-1/3 -translate-x-1/4 blur-3xl pointer-events-none"></div>
         
         <div className="flex flex-col md:flex-row items-center md:items-start text-center md:text-left z-10">
            <div className="bg-white p-4 rounded-2xl text-blue-600 mr-0 md:mr-6 mb-6 md:mb-0 shadow-sm border border-gray-100 group-hover:scale-110 group-hover:rotate-3 transition-transform duration-500 shrink-0">
               <ClipboardList size={32} strokeWidth={1.5} />
            </div>
            <div>
               <span className="text-[#3b82f6] text-[10px] sm:text-xs font-extrabold tracking-widest uppercase mb-2 block">PARTNER WITH US</span>
               <h2 className="text-xl md:text-2xl font-extrabold text-gray-900 mb-2">List your Show on Lokanatya</h2>
               <p className="text-gray-500 text-sm max-w-xl leading-relaxed">Host a show or event! Reach thousands of theatre fans across Odisha effortlessly.</p>
            </div>
         </div>
         
         <button className="bg-[#243b8a] hover:bg-blue-700 text-white font-bold px-8 py-3.5 rounded-xl text-sm shadow-md hover:shadow-lg hover:-translate-y-0.5 mt-8 md:mt-0 whitespace-nowrap transition-all flex items-center gap-2 group/btn z-10 w-full md:w-auto justify-center">
            Contact Today
            <ArrowRight size={16} className="group-hover/btn:translate-x-1 transition-transform" />
         </button>
      </div>
    </div>
  );
}
